/** @jsxImportSource preact */
interface HandoffNoticeProps {
  message?: string;
}

export function HandoffNotice({ message }: HandoffNoticeProps) {
  return (
    <div class="lc-handoff-notice" role="status">
      {message || 'Atendido por humano'}
    </div>
  );
}
